import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const GET_SUMMARY = SERVER_URI + '/reports/get-summary';
const GET_CUSTOMER_CARD_DETAILS = SERVER_URI + '/reports/get-customer-card-details';
const GET_CARD_TRANSACTION = SERVER_URI + '/reports/get-customer-card-transaction';
const GET_RECHRAGE = SERVER_URI + '/reports/get-recharge-card';
const GER_DIRECT_TRANSACTION = SERVER_URI + '/reports/get-direct-transaction';
const GET_NOT_CLAIMED = SERVER_URI + '/reports/get-not-claimed-card';
const GET_SKYCOINS = SERVER_URI + '/reports/get-sky-balance';
const GET_LOYALTY_POINT = SERVER_URI + '/reports/get-sky-balance';
const GET_PARTY_REPORT = SERVER_URI + '/reports/get-party-summary';
const GET_DETAIL_REPORT = SERVER_URI + '/reports/fatch-party-detailed-report';
// const GET_CUSTOMER_ANALYTICS = SERVER_URI + '/reports/get-customer-visit-frequency';
const GET_CUSTOMER_ANALYTICS = SERVER_URI + '/reports/customer-visit-frequency-report';


const GET_CUSTOMER_PROFILING = SERVER_URI + '/reports/get-customer-profiling';
const GET_PARTY_ACTIVITY_ADDONS = SERVER_URI + '/reports/get-party-activity-addons';
const GET_FINANCE_REPORT = SERVER_URI + '/reports/get-consolidated-report-by-product-type';
const GET_FINANCE_PRODUCT_TYPE = SERVER_URI + '/reports/get-consolidated-report-by-product';
const GET_PAYMENT_SUMMRY_REPORT = SERVER_URI + '/reports/get-payment-summry-report';
const GET_PRODUCT_WAISE_GST_REPORT = SERVER_URI + '/reports/get-consolidated-report-by-all-product';
const GET_PARTY_REPORT_DATA = SERVER_URI + '/reports/api/v1/reports/get-party-gst-report';

const GET_PARTY_GST_REPORT = SERVER_URI + '/reports/get-party-gst-report';
const GET_DISCOUNT_SUMMARY = SERVER_URI + '/reports/get-discount-summary-report';
const GET_REVERSEL_POINT = SERVER_URI + '/reports/get-reveresed-points-report';
const GET_CUSTOMER_MEMBERSHIP_REPORT =
    SERVER_URI + "/reports/customer-membership-report";
const GET_CUSTOMER_VISIT_FREQUENCY_BY_WAIVER_REPORT =
    SERVER_URI + "/reports/customer-visit-frequency-report-bywaiver";
const GET_CUSTOMER_REPORT_BY_AGE =
    SERVER_URI + "/reports/customer-report-by-age";

const GET_PARTY_EVENT_REPORT =
    SERVER_URI + "/reports/party-event-report";

const GET_PARTY_BIRTHDAY_MONTH_REPORT =
    SERVER_URI + "/reports/party-birthday-month-report";

const GET_VOID_TRANSACTION_REPORT =
    SERVER_URI + "/reports/void-transaction-report";

const GET_LOCATION_ANALYTIC_REPORT =
    SERVER_URI + "/reports/get-location-analytic-report";

const GET_LOCATION_PAYMENT_SUMMARY_REPORT =
    SERVER_URI + "/reports/get-locatoin-payment-summary-report";

const GET_LOCATION_REVENUE_SUMMARY_REPORT =
    SERVER_URI + "/reports/get-locatoin-revenue-summary-report";

const GET_ALL_CUSTOMER_MEMBERSHIP_REPORT = SERVER_URI + "/reports/get-customer-membership-report"

const GET_INVENTORY_REPORT = SERVER_URI + '/reports/get-inventory-report';

const GET_CUSTOMER_VISIT_DETAILS_REPORT = SERVER_URI + '/reports/get-customer-details-report-on-visit';


const GET_CUSTOMER_WAIVER_DETAILS_REPORT =
    SERVER_URI + '/reports/get-customer-details-report-on-waiver';

const GET_PARTY_DUMP_REPORT =
    SERVER_URI + '/reports/get-party-dump-report';

const GET_AUDIT_REPORT = SERVER_URI + '/reports/get-audit-report';

export default {
    getSummary: async function (payload) {
        return apiPost(GET_SUMMARY, payload)
    },
    getCustomerCardDetails: async function (payload) {
        return apiPost(GET_CUSTOMER_CARD_DETAILS, payload)
    },
    getCardTransaction: async function (payload) {
        return apiPost(GET_CARD_TRANSACTION, payload)
    },
    getRecharge: async function (payload) {
        // console.log("payloaddd...", payload)
        return apiPost(GET_RECHRAGE, payload)
    },
    getDirectTransation: async function (payload) {
        return apiPost(GER_DIRECT_TRANSACTION, payload)
    },
    getNotClaimed: async function (payload) {
        return apiPost(GET_NOT_CLAIMED, payload)
    },
    getSkyCoins: async function (payload) {
        return apiPost(GET_SKYCOINS, payload)
    },
    getLoyaltyPoint: async function (payload) {
        return apiPost(GET_LOYALTY_POINT, payload)
    },
    getPartyReport: async function () {
        return apiGet(GET_PARTY_REPORT)
    },
    getDetailReport: async function (payload) {
        return apiPost(GET_DETAIL_REPORT, payload)
    },
    getCustomerAnalytics: async function (payload) {
        return apiPost(GET_CUSTOMER_ANALYTICS, payload)
    },
    getCustomerProfiling: async function () {
        return apiGet(GET_CUSTOMER_PROFILING)
    },
    getPartyActivityAddOns: async function (party_id, is_activity = true) {
        const isAddOns = !is_activity;
        return apiGet(
            `${GET_PARTY_ACTIVITY_ADDONS}?is_activity=${is_activity}&is_addOns=${isAddOns}&party_id=${party_id}`
        );
    },

    addFinanceReport: async function (payload) {
        return apiPost(GET_FINANCE_REPORT, payload)
    },
    getFinanceProductType: async function (payload) {
        return apiPost(GET_FINANCE_PRODUCT_TYPE, payload)
    },
    getPaymentSummryReport: async function (payload) {
        return apiPost(GET_PAYMENT_SUMMRY_REPORT, payload)
    },
    getProductWiseGstReport: async function (payload) {
        return apiPost(GET_PRODUCT_WAISE_GST_REPORT, payload)
    },
    getPartyGstReport: async function (payload) {
        return apiPost(GET_PARTY_GST_REPORT, payload);
    },
    getDiscountSummary: async function (payload) {
        return apiPost(GET_DISCOUNT_SUMMARY, payload)
    },
    getReverselPointReport: async function (payload) {
        return apiPost(GET_REVERSEL_POINT, payload)
    },
    getCustomerMembershipReport: async function (payload) {
        return apiPost(GET_CUSTOMER_MEMBERSHIP_REPORT, payload);
    },
    getCustomerVisitFrequencyByWaiverReport: async function (payload) {
        return apiPost(GET_CUSTOMER_VISIT_FREQUENCY_BY_WAIVER_REPORT, payload);
    },
    getCustomerReportByAge: async function (payload) {
        return apiPost(GET_CUSTOMER_REPORT_BY_AGE, payload);
    },
    getPartyEventReport: async function (payload) {
        return apiPost(GET_PARTY_EVENT_REPORT, payload);
    },
    getPartyBirthdayMonthReport: async function (payload) {
        return apiPost(GET_PARTY_BIRTHDAY_MONTH_REPORT, payload);
    },
    getVoidTransactionReport: async function (payload) {
        return apiPost(GET_VOID_TRANSACTION_REPORT, payload);
    },
    getLocationAnalyticReport: async function (payload) {
        return apiPost(GET_LOCATION_ANALYTIC_REPORT, payload);
    },
    getLocationPaymentSummaryReport: async function (payload) {
        return apiPost(GET_LOCATION_PAYMENT_SUMMARY_REPORT, payload);
    },
    getLocationRevenueSummaryReport: async function (payload) {
        return apiPost(GET_LOCATION_REVENUE_SUMMARY_REPORT, payload);
    },
    getAllCustomerMembershipReport: async function (payload) {
        return apiPost(GET_ALL_CUSTOMER_MEMBERSHIP_REPORT, payload);
    },
    getInventoryReport: async function (payload) {
        return apiPost(GET_INVENTORY_REPORT, payload)
    },
    getCustomerVisitDetailsReport: async function (payload) {
        return apiPost(GET_CUSTOMER_VISIT_DETAILS_REPORT, payload);
    },
    getCustomerWaiverDetailsReport: async function (payload) {
        return apiPost(GET_CUSTOMER_WAIVER_DETAILS_REPORT, payload);
    },
    getPartyDumpReport: async function (payload) {
        return apiPost(GET_PARTY_DUMP_REPORT, payload);
    },
    getAuditReport: async function (payload) {
    return apiPost(GET_AUDIT_REPORT, payload);
    }
};

